import { MessageCircle } from "lucide-react";

const WA_NUMBER = "905313185280";
const WA_TEXT = "Merhaba, İnci Tel Çit Sistemleri hakkında bilgi almak istiyorum.";

export default function WhatsAppFloat() {
  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_TEXT)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="WhatsApp ile iletişime geç"
      className="fixed bottom-6 right-6 z-50"
    >
      <span className="relative grid place-items-center">
        <span className="absolute inset-0 rounded-full bg-[#25D366] wa-ring" />
        <span
          className="absolute inset-0 rounded-full bg-[#25D366] wa-ring"
          style={{ animationDelay: "0.8s" }}
        />
        <span className="relative grid place-items-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1DA851] shadow-[0_15px_40px_-10px_rgba(37,211,102,0.7)] transition-colors">
          <MessageCircle className="w-6 h-6 text-white fill-white" strokeWidth={0} />
        </span>
      </span>
    </a>
  );
}
